export default "__VITE_ASSET__DfTOCpCc__"